// Module
var code = "<div class=\"im-static-input\"> <div class=\"im-static-words\"></div> <div class=\"im-static-login\"> <div class=\"im-static-login-btn\"> <i class=\"im-static-login-btn-icon\"></i> <span class=\"im-static-login-btn-txt\">我想发送更多信息</span> <div class=\"im-static-login-btn-mask\"></div> </div> </div> </div>";
// Exports
module.exports = code;